// Алерт трекнутого кошелька — прод-порт финала лабы #196 (анатомия
// Axiom-тоста в нашем пиксель-стиле): корпус со срезами, аватар токена
// слева, две строки (кто/глагол/тикер · сумма цветом стороны), контролы
// столбиком справа (✕ сверху, колокол снизу).
//
// ЧЕСТНОСТЬ ДАННЫХ: нотификация трекера НЕ несёт картинку токена, его
// возраст и mcap сделки — поэтому возраст-бейджа и «at $X MC» здесь нет
// (в лабе они были на моках). Рисуем только то, что приходит: кошелёк,
// глагол, тикер, количество, $-оценку (если backend её дал), контрагента
// у переводов. Колокол показывается ТОЛЬКО когда правило трекинга
// известно — иначе это была бы мёртвая кнопка.

import type { WalletTrackerNotification } from '../../api/userland'
import { formatCompact, shortAddr } from '../../lib/format'
import { TokenAvatar } from '../ui/TokenAvatar'
import { BellFilled, BellSimple, X } from '../ui/icons/app'
import styles from '../ui/pixel-toast.module.css'

export type AlertTone = 'buy' | 'sell' | 'transfer'

export function alertTone(n: WalletTrackerNotification): AlertTone {
  if (n.action === 'buy') return 'buy'
  if (n.action === 'sell') return 'sell'
  return 'transfer'
}

export function alertVerb(n: WalletTrackerNotification): string {
  if (n.action === 'buy') return 'bought'
  if (n.action === 'sell') return 'sold'
  return n.direction === 'in' ? 'received' : 'sent'
}

export function alertTicker(n: WalletTrackerNotification): string {
  if (n.token_ticker) return n.token_ticker
  if (n.token_master === 'native') return 'GRAM'
  return shortAddr(n.token_master)
}

function amountLabel(n: WalletTrackerNotification): string {
  const amount = Number(n.token_amount)
  return Number.isFinite(amount) ? formatCompact(amount) : n.token_amount
}

function usdLabel(n: WalletTrackerNotification): string | null {
  return typeof n.value_usd === 'number' && n.value_usd > 0
    ? `$${formatCompact(n.value_usd)}`
    : null
}

export function WalletAlertCard({
  notification,
  onOpen,
  onDismiss,
  bell,
}: {
  notification: WalletTrackerNotification
  onOpen: () => void
  onDismiss: () => void
  /** живой тоггл правила трекинга; без него колокол не рисуем */
  bell?: { on: boolean; toggle: () => void }
}) {
  const tone = alertTone(notification)
  const ticker = alertTicker(notification)
  const who = notification.wallet_label || shortAddr(notification.wallet_address)
  const usd = usdLabel(notification)
  const counterparty = notification.counterparty

  return (
    <>
      <button
        type="button"
        className={styles.aOpen}
        aria-label={`${who} ${alertVerb(notification)} ${ticker} — open token`}
        onClick={onOpen}
      >
        <span className={styles.aArt}>
          <TokenAvatar
            label={ticker}
            dex={notification.source}
            size={34}
            badgeSize={16}
            imageLoading="eager"
          />
        </span>
        <span className={styles.aBody}>
          <span className={styles.aTop}>
            <span className={styles.aWho}>
              <span className={styles.aMark}>{(who.trim()[0] || '?').toUpperCase()}</span>
              <span className={styles.aName}>{who}</span>
            </span>
            <i data-tone={tone}>{alertVerb(notification)}</i>
            <span className={styles.aTicker}>{ticker}</span>
          </span>
          <span className={styles.aMeta}>
            <b data-tone={tone}>
              {amountLabel(notification)} {ticker}
            </b>
            {usd && <span>{usd}</span>}
            {tone === 'transfer' && counterparty && (
              <span className={styles.aAddr}>{shortAddr(counterparty)}</span>
            )}
          </span>
        </span>
      </button>
      <span className={styles.aCtl}>
        <button type="button" className={styles.aClose} aria-label="Dismiss" onClick={onDismiss}>
          <X size={15} />
        </button>
        {bell && (
          <button
            type="button"
            className={styles.aBell}
            data-on={bell.on}
            aria-pressed={bell.on}
            aria-label={bell.on ? 'Mute alerts for this wallet' : 'Unmute alerts for this wallet'}
            onClick={bell.toggle}
          >
            {bell.on ? <BellFilled size={15} /> : <BellSimple size={15} />}
          </button>
        )}
      </span>
    </>
  )
}
